import { useLens } from "../../lens/hooks/useLens";

type SelectedLensQuery = ReturnType<typeof useLens>;
interface SelectedLens {
    lens: NonNullable<SelectedLensQuery["data"]>["getLens"]["lens"] | undefined;
    unlockableId: string | undefined;
    query: SelectedLensQuery;
}

// Resolves the Lens selected for inspection to the unlockable ID monetization queries key on.
export const useSelectedLens = (lensId: string | null | undefined, skip = false): SelectedLens => {
    const query = useLens(lensId ?? "", skip || !lensId);
    const lens = query.data?.getLens.lens;
    return { lens, unlockableId: lens?.unlockableId.toString(), query };
};
